// A 404 arrives as a typed NotFoundError body; a network failure throws before this and has no body.
export const isNotFoundBody = (error: unknown): boolean =>
  typeof error === 'object' && error != null && 'type' in error && error.type === 'NotFoundError'
